import { RootState } from "../../rootReducer";

export const selectIsLoading = (state: RootState) =>
  state.dataGroupClass.loading;
export const selectErrorMessage = (state: RootState) =>
  state.dataGroupClass.error;
export const dataGroupClassResponse = (state: RootState) =>
  state.dataGroupClass.dataGroupClassResponse;
